import { INavData } from '@coreui/angular';

export const navItems = ({
  isTransport = false,
  isFinance = false,
  isAdmin = false,
  isAuditor = false,
}): INavData[] => {
  let items: INavData[] = [];
  const master = {
    name: 'Master',
    url: '/Masters',
    iconComponent: { name: 'cil-puzzle' },
    children: [
      {
        name: 'Account',
        url: '/account',
        iconComponent: { name: 'cil-puzzle' },
        children: [
          { name: 'Ledger', url: 'accountMaster', icon: 'nav-icon-bullet' },
          { name: 'Group', url: 'subgroup', icon: 'nav-icon-bullet' },
          { name: 'Primary Group', url: 'primarygroup', icon: 'nav-icon-bullet' },
          { name: 'Opening Balance', url: 'Opningbalance', icon: 'nav-icon-bullet' },
        ],
      },
      {
        name: 'Location',
        url: '/place',
        iconComponent: { name: 'cil-cursor' },
        children: [
          { name: 'District', url: 'District', icon: 'nav-icon-bullet' },
          { name: 'Taluka', url: 'Taluka', icon: 'nav-icon-bullet' },
          { name: 'Place', url: 'Place', icon: 'nav-icon-bullet' },
        ],
      },

      {
        name: 'Product',
        url: '/product',
        iconComponent: { name: 'cil-notes' },
        children: [
          { name: 'Product Info', url: 'Productmaster', icon: 'nav-icon-bullet' },
          { name: 'Unit', url: 'Unitmaster', icon: 'nav-icon-bullet' },
        ],
      },

      {
        name: 'Vehicle',
        iconComponent: { name: 'bi bi-truck' },
        children: [
          {
            name: 'Vehicle Info',
            iconComponent: { name: 'cil-spreadsheet' },
            url: 'VehicleInfomaster',
          },
          {
            name: 'Vehicle Declaration',
            iconComponent: { name: 'cil-spreadsheet' },
            url: 'Declarationmaster',
          },
          {
            name: 'Vehicle Type',
            iconComponent: { name: 'cil-spreadsheet' },
            url: 'VehicleTypeMaster',
          },
        ],
      },
    ],
  };
  const location = {
    name: 'Location',
    url: '/place',
    iconComponent: { name: 'cil-cursor' },
    children: [
      { name: 'District', url: 'District', icon: 'nav-icon-bullet' },
      { name: 'Taluka', url: 'Taluka', icon: 'nav-icon-bullet' },
      { name: 'Place', url: 'Place', icon: 'nav-icon-bullet' },
    ],
  };
  const product = {
    name: 'Product',
    url: '/product',
    iconComponent: { name: 'cil-notes' },
    children: [
      { name: 'Product Info', url: 'Productmaster', icon: 'nav-icon-bullet' },
      { name: 'Unit', url: 'Unitmaster', icon: 'nav-icon-bullet' },
    ],
  };

  const vehicle = {
    name: 'Vehicle',
    iconComponent: { name: 'bi bi-truck' },
    children: [
      {
        name: 'Vehicle Info',
        iconComponent: { name: 'cil-spreadsheet' },
        url: 'VehicleInfomaster',
      },
      {
        name: 'Vehicle Declaration',
        iconComponent: { name: 'cil-spreadsheet' },
        url: 'Declarationmaster',
      },
      {
        name: 'Vehicle Type',
        iconComponent: { name: 'cil-spreadsheet' },
        url: 'VehicleTypeMaster',
      },
    ],
  };

  const transactionFinChildren: INavData[] = [
    { name: 'Other Purchase', iconComponent: { name: 'cil-credit-card' }, url: 'Otherpurmaster' },
    { name: 'Debit Note', iconComponent: { name: 'cil-notes' }, url: 'Debitnotemaster' },
    { name: 'Credit Note', iconComponent: { name: 'cil-notes' }, url: 'Creditnotemaster' },
    { name: 'Contra Entry', iconComponent: { name: 'cil-credit-card' }, url: 'Contramaster' },
    { name: 'Journal Entry', iconComponent: { name: 'cil-notes' }, url: 'Journalmaster' },
    { name: 'Receipt', iconComponent: { name: 'cil-credit-card' }, url: 'Receiptmaster' },
    { name: 'Payment', iconComponent: { name: 'cil-credit-card' }, url: 'Paymentmaster' },
  ];

  const transactionTransChildren: INavData[] = [
    { name: 'Bilty/Memo', iconComponent: { name: 'cil-credit-card' }, url: 'BiltyMaster' },
    { name: 'Lorry Receipt', iconComponent: { name: 'cil-file' }, url: 'Motormaster' },
    {
      name: 'Bilty Status',
      iconComponent: { name: 'cil-layers' },
      url: 'BiltyStatus',
    },
    {
      name: 'Aknowledgment',
      iconComponent: { name: 'cil-credit-card' },
      url: 'Aknowledgment1',
    },
    {
      name: 'Transport Invoice',
      iconComponent: { name: 'cil-credit-card' },
      url: 'masterinvoice',
    },
  ];

  const reportAuditChildren: INavData[] = [
    { name: 'Trial Balance', iconComponent: { name: 'cil-list' }, url: 'Trialbalance' },
    { name: 'Balance Sheet', iconComponent: { name: 'cil-list' }, url: 'balancesheet' },
    { name: 'Profit Loss', iconComponent: { name: 'cil-list' }, url: 'profitloss' },
  ];

  const reportTransportChildren: INavData[] = [
    {
      name: 'Bilty/Memo Register',
      iconComponent: { name: 'cil-list' },
      url: 'BiltyRegister',
    },
    {
      name: 'L.R. Register(Transport)',
      iconComponent: { name: 'cil-list' },
      url: 'lr-register-transport',
    },
    {
      name: 'L.R. Register(Consignor)',
      iconComponent: { name: 'cil-list' },
      url: 'lr-register-consignor',
    },
    { name: 'Sundry Item Register', iconComponent: { name: 'cil-list' }, url: 'sundry-wise' },
    // { name: 'Lorry Receipt 2 Register', iconComponent: { name: 'cil-list' }, url: 'lorry-receipt2_Register' },

    {
      name: 'Transport Invoice Register',
      iconComponent: { name: 'cil-list' },
      url: 'TransInvReg',
    },

    {
      name: 'Bilty Pending Register',
      iconComponent: { name: 'cil-list' },
      url: 'PendingBiltyReg',
    },
    {
      name: 'Transport Bill Pending Register',
      iconComponent: { name: 'cil-list' },
      url: 'TransBillPendingReg',
    },
  ];
  let report: INavData = {
    name: 'Report',
    url: '/Reports',
    iconComponent: { name: 'cil-puzzle' },
    children: [
      { name: 'Cash/Bank Book', iconComponent: { name: 'cil-file' }, url: 'cashbankbook' },
      { name: 'Day Book', iconComponent: { name: 'cil-list' }, url: 'daybook' },
      { name: 'Ledger', iconComponent: { name: 'cil-list' }, url: 'Ledger' },
      { name: 'Group List', iconComponent: { name: 'cil-list' }, url: 'SubGroupreport' },
      { name: 'TDS Register', iconComponent: { name: 'cil-list' }, url: 'tds-register' },
    ],
  };
  let transaction: INavData = {
    name: 'Transaction',
    url: '/Transactions',
    iconComponent: { name: 'cil-puzzle' },
    children: [],
  };

  const admin: INavData = {
    name: 'Admin',
    url: '/Admins',
    iconComponent: { name: 'cil-puzzle' },
    children: [
      //  { name: 'Firms', iconComponent: { name: 'cil-layers' }, url: 'FirmMaster' },
      { name: 'Company Profile', iconComponent: { name: 'cil-layers' }, url: 'FirmEdit' },
      // { name: 'Financial Year', iconComponent: { name: 'cil-calendar' }, url: 'Finyearmaster' },
      { name: 'TDS On Transportation', url: 'Tdsmaster', icon: 'nav-icon-bullet' },
      { name: 'Transportation Sundry', url: 'accountSundry', icon: 'nav-icon-bullet' },
      {
        name: 'Balance Forward',
        iconComponent: { name: 'cil-calculator' },
        url: 'Balanceforward',
      },
      // { name: 'Firm Type', iconComponent: { name: 'cil-layers' }, url: 'Firmtypemaster' },

      // { name: 'RoleInfo', iconComponent: { name: 'cil-layers' }, url: 'Roleinfomaster' },
      { name: 'Setting', iconComponent: { name: 'cil-layers' }, url: 'setting' },
      { name: 'Dueties And Taxes', iconComponent: { name: 'cil-layers' }, url: 'duetiestaxes' },
      {
        name: 'Cancel Aknowledgment',
        iconComponent: { name: 'cil-layers' },
        url: 'cancelaknowl',
      },

      {
        name: 'User Management',
        iconComponent: { name: 'cil-layers' },
        url: '/user-management',
        children: [
          { name: 'User Info', iconComponent: { name: 'cil-layers' }, url: 'Userinfomaster' },
          {
            name: 'Permission',
            url: '/Permission',
            iconComponent: { name: 'cil-notes' },
            children: [
              { name: 'User Access', iconComponent: { name: 'cil-layers' }, url: 'UserAccess' },
              // { name: 'Role Access', iconComponent: { name: 'cil-layers' }, url: 'Roleaccess' },
              { name: 'Module Access', iconComponent: { name: 'cil-layers' }, url: 'Moduleaccess' },
            ],
          },
        ],
      },
    ],
  };

  if (isFinance) items.push(master);
  items.push(location);

  if (isTransport) {
    items.push(product);
    items.push(vehicle);
  }

  if (isFinance || isTransport) {
    if (isFinance) transaction.children.push(...transactionFinChildren);
    if (isTransport) transaction.children.push(...transactionTransChildren);
    items.push(transaction);
  }
  if (isAuditor || isFinance || isTransport) {
    if (isAuditor || isFinance) report.children.push(...reportAuditChildren);
    if (isTransport) report.children.push(...reportTransportChildren);
    items.push(report);
  }

  if (isAdmin) items.push(admin);

  return items;
};
